<div style="min-height:80vh;max-height:80vh;">
    <div fxLayout="row" mat-dialog-title>
        <div fxFlex>
            <h2 mat-dialog-title>Validation des rapports de consultation</h2>
        </div>
        <div fxFlex="160px" class="item-panel-toolbar">
            <button mat-stroked-button (click)="sendEmail()">Envoyer un email</button>
        </div>
        <div fxFlex="120px" class="item-panel-toolbar">
            <mat-checkbox [checked]="selectAll" (change)="select($event.checked)">Tous</mat-checkbox>
        </div>
        <div fxFlex="400px" class="item-panel-toolbar">
            <app-user-selection style="margin-left: 20px;margin-top: 5px;" (selected)="selectUser($event)" [label]="'Prestataire'" [mode]="'list'" [userClass]="'SNItem.SNUser.CNUser.CNHealthAgent'"></app-user-selection>
        </div>
        <div fxFlex="120px" class="item-panel-toolbar">
            <mat-slide-toggle [(ngModel)]="isValidated" (change)="toggleChanged($event)">Validés</mat-slide-toggle>
        </div>
    </div>
    <div style="min-height:calc(75vh - 80px);">
        <app-report-table #reporttable class="widget-content" (selected)="selectedReport($event)" [selectable]="true" [selectall]="selectAll" [reports]="reports" [paginator]="false"></app-report-table>
    </div>
</div>